<template>
  <div>
    <div v-if="this.can_edit" class="container-stepper">
      <v-stepper v-if="GETTERS_FILES !== null"
        alt-labels
        v-model="current_step"
        class="header-stepper-container">

        <v-row>
          <v-col cols="3" class="pa-4 pl-6">
            <v-chip
              class="mr-2"
              @click="back_to_proposal_list()"
              color='#15336d'
              dark
            >
              <v-icon   left>mdi-arrow-left</v-icon>
              {{$t("list-proposals")}}
            </v-chip>
          </v-col>
          <v-col cols="4" class="pt-5">
            <h2 class="ma-0">{{$t("proposal")}} № {{this.$route.params.id}} </h2>
          </v-col>
          <v-col cols="5" style="text-align: end;">
            <v-list class="pa-0">
              <v-list-item class="pa-0" style="height: 20px !important;">
                <v-list-item-content class="pa-0">
                  <v-list-item-title @click="openGuide()" style="cursor: pointer;">
                    Памятка по написанию заявок
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn @click="openGuide()" icon>
                    <v-icon color="grey lighten-1">mdi-download</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>



      <v-stepper-header  class="header-steper">
        <v-stepper-step
          color="#15336d"
          :rules="[() => GETTERS_NEW_PROPOSAL_STEPPER_CHECK_STATUS.step1 || current_step == 1]"
          :editable="true"
          step="1"
          @click="NEW_PROPOSAL_UPDATE_STEP(1)"
        >{{$t("step-0-info")}}
        </v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step
          color="#15336d"
          :rules="[() => GETTERS_NEW_PROPOSAL_STEPPER_CHECK_STATUS.step2 || current_step == 2]"
          :editable="true"
          step="2"
          @click="NEW_PROPOSAL_UPDATE_STEP(2)"
        >{{$t("step-1-info")}}
        </v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step
          color="#15336d"
          :rules="[() => GETTERS_NEW_PROPOSAL_STEPPER_CHECK_STATUS.step3 || current_step == 3]"
          :editable="true"
          step="3"
          @click="NEW_PROPOSAL_UPDATE_STEP(3)"
        >{{$t("step-2-info")}}
        </v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step
          color="#15336d"
          :rules="[() => GETTERS_NEW_PROPOSAL_STEPPER_CHECK_STATUS.step4 || current_step == 4]"
          :editable="true"
          step="4"
          @click="NEW_PROPOSAL_UPDATE_STEP(4)"
        >{{$t("step-3-info")}}
        </v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step
          color="#15336d"
          :rules="[() => GETTERS_NEW_PROPOSAL_STEPPER_CHECK_STATUS.step5 || current_step == 5]"
          :editable="true"
          step="5"
          @click="NEW_PROPOSAL_UPDATE_STEP(5)"
        >{{$t("step-4-info")}}</v-stepper-step>
        <v-divider></v-divider>
        
        <v-stepper-step
          color="#15336d"
          :editable="true"
          step="6"
          @click="NEW_PROPOSAL_UPDATE_STEP(6)"
        >{{$t("step-5-info")}}</v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step
          color="#15336d"
          :editable="true"
          step="7"
          @click="NEW_PROPOSAL_UPDATE_STEP(7)"
        >{{$t("step-6-info")}}</v-stepper-step>
      
      </v-stepper-header>
      
      <v-stepper-items>
        <v-stepper-content step="1" class="container-stepper-content">
          <TypeStep
            :name="GETTERS_FILES.name"
            :scientific_subjects="GETTERS_FILES.scientific_subjects"
            :keywords="GETTERS_FILES.keywords"
            :previous_proposals="GETTERS_FILES.previous_proposals"
            :agreement_type="GETTERS_FILES.agreement_type"
            :agreement_text="GETTERS_FILES.agreement_text"
          />
        </v-stepper-content>

        <v-stepper-content step="2" class="container-stepper-content">
          <InfoStep
            :problem_formulation="GETTERS_FILES.problem_formulation"
            :backgrounds="GETTERS_FILES.background"
            :expected_results="GETTERS_FILES.expected_results"
          />
        </v-stepper-content>

        <v-stepper-content step="3" class="container-stepper-content">
          <ToolSelection/>
        </v-stepper-content>
        


        <v-stepper-content step="4" class="container-stepper-content">
          <Safety
            :is_toxic="GETTERS_FILES.is_toxic"
            :is_different_dangerous="GETTERS_FILES.is_different_dangerous"
            :is_biohazard="GETTERS_FILES.is_biohazard"
            :other_dangers="GETTERS_FILES.other_dangers"
            :sample_description="GETTERS_FILES.sample_description"
            :sample_type_id="GETTERS_FILES.sample_type_id"
            :sample_avarage_size="GETTERS_FILES.sample_avarage_size"
            :sample_volume="GETTERS_FILES.sample_volume"
            :sample_surface_area="GETTERS_FILES.sample_surface_area"
            :sample_mass="GETTERS_FILES.sample_mass"
            :sample_count="GETTERS_FILES.sample_count"
          />
        </v-stepper-content>
        
        <v-stepper-content step="5" class="container-stepper-content">
          <SelectionDate
            :local_contacts="GETTERS_FILES.local_contacts"
            :can_work_at_night="GETTERS_FILES.can_work_at_night"
            :experiment_calendar="dateRange"
            :teams="all_teams"
          />
        </v-stepper-content>
        
        <v-stepper-content step="6" class="container-stepper-content">
          <Files
            @update_data="update(GETTERS_DATA_QUIZE)"
            :files_api="GETTERS_FILES.files"
          />
        </v-stepper-content>
        
        <v-stepper-content step="7" class="container-stepper-content">
          <Finish/>
        </v-stepper-content>
      </v-stepper-items>

      <v-row>
        <v-col>
          <div class="text-left">
            <v-btn v-if="current_step > 1" class="ma-2" @click="prev_step"  :color="$mainColor" dark>{{$t('prev')}}</v-btn>
          </div>
        </v-col>
        <v-col>
          <div class="text-right">
            <v-btn v-if="current_step < 7" class="ma-2" @click="next_step"  :color="$mainColor" dark>{{$t('next-step')}}</v-btn>
          </div>
        </v-col>
      </v-row>
      
    </v-stepper>
  </div>

  <update-button v-if="this.can_edit" @update="update(GETTERS_DATA_QUIZE)" />
    
    <v-dialog v-if="!can_edit"
      :persistent="true"
      v-model="error_dialog"
      width="600">
      <v-card>
        <v-card-title
          class=""
          primary-title>
          {{$t('NewProposal.notification_header')}}
        </v-card-title>
        <v-card-text>
          {{$t('NewProposal.editing_application')}}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="close_modal()">
              {{$t('ok')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--widget-render-file
        :name="'newProposal'" /-->
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import UpdateButton from '../components/Common/UpdateButton.vue';

import TypeStep from '../components/NewProposal/Step_1_TypeStep.vue';
import InfoStep from '../components/NewProposal/Step_2_InfoStep.vue'
import ToolSelection from '../components/NewProposal/Step_3_ToolSelection.vue';
import Safety from '../components/NewProposal/Step_4_Safety.vue';
import SelectionDate from '../components/NewProposal/Step_5_SelectionDate.vue';
import Files from '../components/NewProposal/Step_6_Files.vue';
import Finish from '../components/NewProposal/Step_7_Finish.vue';

// import WidgetRenderFile from '../components/widgets/render-file'
import { DOMEN } from '../../vars.js';

export default {
  name: 'NewProposal',
  components: {
    TypeStep,
    InfoStep,
    Files,
    ToolSelection,
    Safety,
    SelectionDate,
    UpdateButton,
    Finish,
    // WidgetRenderFile
  },
   data() {
    return {
      can_edit: false,

      dateRange: [],
      color: '#4caf50',
      timeout: 3000,
      current_step: 1,
      edit: false,
      name: '',
      infoStep: {
        name: '',
        scientificContent: '',
        strategy: '',
        scientificGroundWork: '',
        expectedResults: '',
      },

      error_dialog: true,
      save_wait: false,
      all_teams: [],
    };
  },
  methods: {
    ...mapActions([
      'REQUEST_NEW_PROPOSAL_DATA',
      'PROPOSAL_DETAIL_UPDATE',
      'logged',
      'PROPOSAL_GET_TEAM',
      'GET_PROPOSAL_AVAILABLE_ACTIONS',
      'GET_REFERENCE',
    ]),
    ...mapMutations([
      'UPDATE_OVERLAY',

      'NEW_PROPOSAL_UPDATE_STEP',
    ]),

    openGuide(){
      window.open(DOMEN + `/media/ProposalSubmissionGuide.pdf`, '_blank')
    },
    
    back_to_proposal_list(){
      var data = this.GETTERS_DATA_QUIZE
      data.id = Number(this.$route.params.id);

      this.UPDATE_OVERLAY(true)
      this.PROPOSAL_DETAIL_UPDATE(data)
        .then(() => {
          this.UPDATE_OVERLAY(false)
          this.$router.push('/user')
        });
    },

    update(data) {
      data.id = Number(this.$route.params.id);
      setTimeout(() => {
          this.PROPOSAL_DETAIL_UPDATE(data)
          .then(() => {
            this.$messageHelper(this.$t("data-succeded"), 'success')
          });
      }, 1000);
    },

    silent_save(){
      if(this.save_wait){
        setTimeout(() => {
          this.silent_save();
        }, 1000);
      }
      else{
        this.save_wait = true
        var data = this.GETTERS_DATA_QUIZE
        data.id = Number(this.$route.params.id);

        this.PROPOSAL_DETAIL_UPDATE(data)
          .then(() => {
            this.save_wait = false;
          });
      }
    },

    next_step() {
      window.scrollTo(0,0);
      this.NEW_PROPOSAL_UPDATE_STEP(parseInt(this.current_step)+1)
    },

    prev_step() {
      window.scrollTo(0,0);
      this.NEW_PROPOSAL_UPDATE_STEP(parseInt(this.current_step)-1)
    },

    close_modal() {
      this.$router.push('/user')
    },
    
    load_proposal_data(){
      this.UPDATE_OVERLAY(true)
      this.GET_PROPOSAL_AVAILABLE_ACTIONS(this.$route.params.id).then(res => {
        this.can_edit = res.edit_new_proposal
      })

      this.REQUEST_NEW_PROPOSAL_DATA(this.$route.params.id)
        .then(() => {
          this.UPDATE_OVERLAY(false)
      });

      this.PROPOSAL_GET_TEAM(this.$route.params.id)
        .then((res) => {
          this.all_teams = res.all_teams
      });
    },
  },

  async beforeMount() {
    if(this.GETTERS_REFERENCES('scientific_area').length == 0){
      this.GET_REFERENCE({bd_name: 'scientific_area'})
    }
    if(this.GETTERS_REFERENCES('method').length == 0){
      this.GET_REFERENCE({bd_name: 'method'})
    }

    this.load_proposal_data()
  },

  computed: {
    ...mapGetters([
      'GETTERS_DATA_QUIZE',
      'GETTERS_FILES',
      'GETTERS_REFERENCES',

      'GETTERS_NEW_PROPOSAL_STEPPER_CHECK_STATUS',
      'GETTERS_NEW_PROPOSAL_CURRENT_STEP',
    ]),
    isLoggedIn() {
      return this.$store.state.isLoggedIn;
    },
  },

  watch: {
    'GETTERS_NEW_PROPOSAL_CURRENT_STEP'(val) {
      this.current_step = val
      this.silent_save()
    },

    GETTERS_FILES(val) {
      if (typeof val.experiment_calendar === 'string') {
        const date = val.experiment_calendar.split(':');
        if(date[0] == 'undefined' || date[1] == 'undefined')
          this.dateRange = [] 
        else
          this.dateRange.push(date[0], date[1])
      }
    }
  }
};
</script>

<style scoped>
  .container-stepper-content{
    /* padding-top:50px; */
    position: relative;
  }

  .my-3 {
    padding-left: 15px;
    padding-right: 15px;
  }
  .title-page{
    margin-top: 40px;
    margin-bottom: 30px;
    margin-left: 20px;
    font-weight: 400;
  }
  .container-stepper{
    margin:10% auto;
    margin-top: 80px;
    width:80%;
    position: relative;
  }
  .preloader-component-step {
    margin-top: 15px;
  }
  .v-stepper__header{
    box-shadow: none;
    
  }
  .v-stepper.header-stepper.v-stepper--is-booted.theme--light{
    box-shadow: none;
    
  }
  .header-steper{
    /* padding-top:10px; */
    background-color:rgba(0, 0, 0, 0.05);
    /* border: 1px solid #15336d; */
  }
  .v-stepper__label {
    color: white !important;
  }
  .v-stepper{
    margin-top:30px;
    -webkit-box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    box-shadow: 1px 5px 24px 0 rgba(124,77,255,.05);
    border-width: 0;
    -webkit-transition: all .2s;
    transition: all .2s;
    background-color: #fff;
    border-radius: 13px!important;
  }
  </style>
